import correct from '@/assets/img/documents/registration-card.jpg';
import wrong from '@/assets/img/documents/registration-card-wrong.jpg';
import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const REGISTRATION_CARD_NAME = 'registration_card';

const RegistrationCard = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t(
      'Jak poprawnie dodać zdjęcie lub skan dowodu rejestracyjnego?'
    ),
    steps: [
      i18n.t('Upewnij się, że dodajesz obie strony dowodu.'),
      i18n.t('Sprawdź, czy wszystkie dane pojazdu są widoczne.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Zdjęcie lub skan dowodu rejestracyjnego')}
          instructionProps={instructionProps}
          inputFieldName={REGISTRATION_CARD_NAME}
          attachmentTypeId={ATTACHMENT_TYPES.KOPIE_DOWODU_REJESTRACYJNEGO}
        />
      </Card>
      <ChatMessage
        variant="secondary"
        className="mt-3 lg:mt-5"
        description={i18n.t(
          'Wgraj teraz zdjęcia lub skany dowodu rejestracyjnego uszkodzonego pojazdu. Pozwoli nam to sprawdzić historię szkodową pojazdu oraz jego wyposażenie.'
        )}
      />
    </div>
  );
};

export default RegistrationCard;
